export async function fetchJson(...params) {
  try {
    const response = await fetch(...params)

    if (!response.ok) return { error: new Error(`${response.status} ${response.statusText}`), response }

    return { response, data: await response.json() }
  } catch (error) {
    return { error }
  }
}

export async function fetchXhr(url, options = {}) {
  try {
    const meta = document.querySelector("meta[name=csrf-token]")

    const response = await fetch(url, {
      ...options,
      headers: {
        accept: "application/javascript",
        "x-csrf-token": meta ? meta.getAttribute("content") : undefined,
        "x-requested-with": "XMLHttpRequest",
        ...(options.headers || {}),
      }
    })

    if (!response.ok) return { error: new Error(`${response.status} ${response.statusText}`), response }

    return { response, data: await response.text() }
  } catch (error) {
    return { error }
  }
}

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.onload = resolve
    script.onerror = reject
    script.type = "text/javascript"
    script.src = url
    document.body.appendChild(script)
  })
}

